import { FormikErrors, useFormik } from 'formik';
import {
  Button,
  Dialog,
  Grid,
  TextField
} from 'src/components';
import GnlParametreSelect from './gnl.parametre.select';
import { useState } from 'react';
import ParametreGrupEnum from "src/enums/ParametreGrupEnum";
import DialogTitle from 'src/components/DialogTitle';
import DialogContent from 'src/components/DialogContent';
import DialogActions from 'src/components/DialogActions';
import { translate } from 'src/i18n/tHelper';

class IptalNedenModel {
  key: number = null;
  value: string = '';
}

interface IIptalNedenSecimProps {
  open: boolean;
  aciklamaRequired?: boolean;
  onSelected: (iptalNedenId: number, aciklama?: string, iptalValue?: string) => void;
  onClosed: () => void;
  title?: string;
  parameterType: ParametreGrupEnum;
  loading?: boolean;
  reddetMi?: boolean; //Reddet ise title ve labellar rede göre değişir
  label?: string;
}

const translatePath = "pages|iptalNedenSecim";
const IptalNedenSecim = (props: IIptalNedenSecimProps): JSX.Element => {
  const [iptalValueState, setIptalValueState] = useState("");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: new IptalNedenModel(),
    validateOnChange: false,
    onSubmit: async (e, v) => {
      props.onSelected(e.key, e.value, iptalValueState);
      props.onClosed();
    },
    validate: (v) => {
      const error: FormikErrors<IptalNedenModel> = {};
      if (!(v) || v.key === -1) {
        error.value = translate(translatePath, 'Lütfen iptal nedeni seçiniz.')
      }

      return error;
    }
  });
  return (
    <Dialog fullWidth open={props.open} maxWidth="sm">
      <DialogTitle id="iptal-neden-secimi">{props.reddetMi ? props.title : props.title ? props.title + ' İptal' : null}</DialogTitle>
      <DialogContent>
        <Grid container sx={{ p: 1 }}>
          <Grid item xs={12}>
            <GnlParametreSelect
              parametreType={props.parameterType}
              name="key"
              value={formik.values?.key}
              onChange={(e, v) => {
                if (!v?.value)
                  return;
                setIptalValueState(v?.value);
                formik.handleChange(e);
              }}
              error={formik.errors.key ? true : false}
              helperText={formik.errors.key}
              label={props.label ? props.label : props.reddetMi ? translate(translatePath, 'Red Nedeni') : translate(translatePath, 'İptal Nedeni')}
            />
          </Grid>
          {props.aciklamaRequired && (
            <Grid item xs={12}>
              <TextField
                value={formik.values?.value}
                name="value"
                multiline
                minRows={3}
                maxRows={6}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.value)}
                helperText={formik.errors.value}
                onBlur={formik.handleBlur}
                label={translate(translatePath, 'Açıklama')}
              ></TextField>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="right">
          <Grid item xs={12} sm={6}>
            <Button customType="save" disabled={!formik.dirty} loading={props.loading} onClick={formik.submitForm}></Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button customType="cancel" onClick={(e) => { props.onClosed(); }}></Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default IptalNedenSecim;
